import React, { Component } from 'react';
import { Form, Label, Input, Row, Col, Button } from 'reactstrap';
import Header from './HeaderComponent';

class Stack extends Component{
    constructor(props){
        super(props);
        this.state = {
            stack: [],
            top: -1,
            lastPoppedItem: null
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.createArray = this.createArray.bind(this);
        this.handlePush = this.handlePush.bind(this);
        this.handlePop = this.handlePop.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    createArray(len, item){
        var arr1 = [item],
        arr2 = [];
        while (len > 0) {
            if (len & 1) arr2 = arr2.concat(arr1);
            arr1 = arr1.concat(arr1);
            len >>>= 1;
        }
        return arr2;
    }
    handleSubmit(event){
        this.handleReset()
        var value = parseInt(this.size.value);
        var temp = this.createArray(value+1, null);
        this.setState({
            stack: temp
        });
        event.preventDefault();

    }
    handlePush(event){
        if(this.state.top<this.state.stack.length-2){
            var temp = this.state.stack;
            temp[this.state.top + 1] = this.nextItem.value;
            this.setState({
                stack: temp,
                top: this.state.top + 1
            });
        }
        else{
            alert('Cannot Push. Stack is full');
        }
        event.preventDefault();
    }
    handlePop(){
        if(this.state.top > -1){
            var temp = this.state.stack;
            var lastPoppedItem = temp[this.state.top];
            temp[this.state.top] = null;
            this.setState({
                top: this.state.top - 1,
                stack: temp,
                lastPoppedItem: lastPoppedItem
            });
        }
        else{
            alert("Cannot Pop. Stack is empty.");
        }
    }
    handleReset(){
        this.setState({
            stack: [],
            top: -1,
            lastPoppedItem: null
        });
    }
    render(){
        var renderStack = this.state.stack.map((item, index)=>{
            return(
                <div key={index} className="row">
                    {this.state.stack.length - 2 - index !== -1?<div className="col-5 text-center align-self-center bg-warning" style={{minHeight:70, display:"flex", alignItems:"center", justifyContent:"center", border: "black 2px solid"}}><h3>{this.state.stack[this.state.stack.length - index - 2]}</h3></div>:<div className="col-5" style={{minHeight:70, display:"flex", alignItems:"center", justifyContent:"center"}}></div>}
                    <div className="col-1 align-self-center">
                        {this.state.stack.length - index - 2}
                    </div>
                    <div className="col-2 align-self-center">
                        <div>{this.state.top === this.state.stack.length - 2 - index? <div key={index}><i className="fa fa-arrow-left"></i> top</div> : <div></div>}</div>
                    </div>
                </div>
            );
        })
        return(
            <>
                <Header destination="Stack"/>
                <div className="container mb-2">
                    <div className="p-2 border black-yellow">
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <h4>Introduction to Stack</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <p>Stack is a linear data structure which follows a particular order in which the operations are performed. The order may be LIFO(Last In First Out) or FILO(First In Last Out).</p>
                                <p>There are many real-life examples of a stack. Consider an example of plates stacked over one another in the canteen. The plate which is at the top is the first one to be removed, i.e. the plate which has been placed at the bottommost position remains in the stack for the longest period of time. So, it can be simply seen to follow LIFO(Last In First Out)/FILO(First In Last Out) order.</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <h4>Operations on Stack</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                The two main operations on Stack are:-
                                <ul>
                                    <li><b>Push:</b> Adds an item in the stack. If the stack is full, then it is said to be an Overflow condition.</li>
                                    <li><b>Pop:</b> Removes an item from the stack. The items are popped in the reversed order in which they are pushed. If the stack is empty, then it is said to be an Underflow condition.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-12">
                            <h4>Visualization</h4>
                        </div>
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        <Row className="form-group">
                            <Col md={2}>
                                <Label htmlFor="size">Size</Label>
                            </Col>
                            <Col md={6}>
                                <Input required type="number" id="size" name="size" innerRef={(input) => this.size = input}/>
                            </Col>
                            <Col md={2}>
                                <Button color="primary" type="submit">Update</Button>
                            </Col>
                        </Row>
                    </Form>
                    <Form onSubmit={this.handlePush}>
                        <Row className="form-group">
                            <Col md={2}>
                                <Label htmlFor="nextItem">Push</Label>
                            </Col>
                            <Col md={6}>
                                <Input required type="number" id="nextItem" name="nextItem" innerRef={(input) => this.nextItem = input}/>
                            </Col>
                            <Col md={2}>
                                <Button color="primary" type="submit">Push</Button>
                            </Col>
                        </Row>
                    </Form>
                    <div className="row">
                        <div className="col-6">
                            <p>Size of Stack = {this.state.stack.length === 0? 0 : this.state.stack.length - 1}</p>
                        </div>
                        <div className="col-3">
                            <Button onClick={this.handlePop} color="warning">Pop</Button>
                        </div>
                        <div className="col-3">
                            <Button onClick={this.handleReset} color="danger">Reset</Button>
                        </div>
                    </div>
                    {renderStack}
                </div>
            </>
        );
    }
}

export default Stack;